const IMAGE_EXTENSION = /\.(png|jpe?g|gif|webp|svg)(?:[?#].*)?$/i;

export function isSafeProductUrl(value) {
  const raw = String(value || "").trim();
  if (!raw) return false;
  if (raw.startsWith("/") && !raw.startsWith("//")) return true;
  try {
    const parsed = new URL(raw, window.location.origin);
    if (!["http:", "https:"].includes(parsed.protocol)) return false;
    const host = parsed.hostname.toLowerCase();
    return !["localhost", "127.0.0.1", "0.0.0.0", "::1"].includes(host);
  } catch (_error) {
    return false;
  }
}

export function isSupportedProductImageUrl(value) {
  if (!isSafeProductUrl(value)) return false;
  const raw = String(value).trim();
  return (
    IMAGE_EXTENSION.test(raw) ||
    /https?:\/\/api\.asicentral\.com\/v1\/media\//i.test(raw) ||
    /https?:\/\/media\.asicdn\.com\//i.test(raw) ||
    /\/customer-files\//i.test(raw) ||
    /\/custom-products\//i.test(raw)
  );
}

export function resolveProductImage(input = {}) {
  const sku = input.sku && typeof input.sku === "object" ? input.sku : {};
  const product = input.product && typeof input.product === "object" ? input.product : {};
  const candidates = [
    input.productImageUrl,
    input.image_url,
    input.imageUrl,
    sku.productImageUrl,
    sku.image_url,
    sku.imageUrl,
    sku.image,
    sku.thumbnailUrl,
    sku.thumbnail,
    product.productImageUrl,
    product.image_url,
    product.imageUrl,
    product.image,
    input.productUrl,
    sku.product_url,
    sku.productUrl,
  ];
  return candidates.find(isSupportedProductImageUrl) || null;
}
